import { ArrowLeftIcon } from '@heroicons/react/24/solid'
import { FC } from 'react'

import { DetailedInviteWithStatus } from '@/api/models/users/lib/invites.types'
import { SOMETHING_WENT_WRONG } from '@/app/constants/index'
import { AppButton } from '@/components/shared/button'

import { SetUserProfileRoute } from '../hooks/useUserProfileRoute'
import {
  inviteCreationStageTitle,
  userProfileBackRoute,
  userProfileTitle
} from '../lib/constants'
import { InviteCreationStage, UserProfileScreens } from '../lib/types'
import { useUserProfileStore } from '../model/store'
import { InviteStatus } from './UserContactsScreen'
import { useUserContactsStore } from './UserContactsScreen/model/store'

type Props = {
  userProfileScreen: string
  setUserProfileRoute: SetUserProfileRoute
  invite?: DetailedInviteWithStatus
}

const UserProfileHeader: FC<Props> = ({
  userProfileScreen,
  setUserProfileRoute,
  invite
}) => {
  const { isError, errorTitle, inviteCreationStage, setInviteCreationStage } =
    useUserProfileStore()
  const { setSelectedProjects } = useUserContactsStore()

  if (isError) {
    return errorTitle ?? SOMETHING_WENT_WRONG
  }

  const onButtonClick = () => {
    if (
      userProfileScreen === UserProfileScreens.InviteCreation &&
      inviteCreationStage === InviteCreationStage.Confirmation
    ) {
      setInviteCreationStage(InviteCreationStage.Create)
      return
    }

    setSelectedProjects(undefined)
    setUserProfileRoute(userProfileBackRoute[userProfileScreen])
  }

  const title =
    userProfileScreen === UserProfileScreens.InviteCreation
      ? inviteCreationStageTitle[inviteCreationStage]
      : userProfileTitle[userProfileScreen]

  const isInviteCreationFinalStage =
    userProfileScreen === UserProfileScreens.InviteCreation &&
    (inviteCreationStage === InviteCreationStage.CreationSucceed ||
      inviteCreationStage === InviteCreationStage.CreationFailed)

  const showBackButton =
    userProfileScreen !== UserProfileScreens.Profile &&
    !isInviteCreationFinalStage

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-8">
        {showBackButton && (
          <AppButton
            aria-label="Вернуться назад"
            variant="uncolored"
            className="!h-28 !p-0"
            onClick={onButtonClick}
          >
            <ArrowLeftIcon className="h-28 w-28 sm:h-24 sm:w-24" />
          </AppButton>
        )}
        <h3>{title}</h3>
      </div>
      {invite && (
        <InviteStatus
          name={invite.statusName}
          color={invite.statusColor}
          iconUrl={invite.statusIconUrl}
        />
      )}
    </div>
  )
}

export default UserProfileHeader
